import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Course from "./pages/Course";
import Category from "./pages/Category";
import SLNEye from "./pages/SLNEye";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Payment from "./pages/Payment";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Dashboard from "./pages/Dashboard";
import Certificates from "./pages/EnrolledCourses";
import Payments from "./pages/Payments";
import Settings from "./pages/Settings";
import ExploreCourse from "./pages/ExploreCourse";
import SLNScanLive from "./pages/SLNScanLive";
import Otp from "./pages/Otp";
import OptionChain from "./pages/OptionChain";
import AllCompaniesStock from "./pages/AllCompaniesStock";
import SectorStrength from "./pages/SectorStrength";
import OILiner from "./pages/OILiner";
import ProtectedRoute from "./ProtectedRoute";
import Cart from "./pages/Cart";
import AllCourses from "./pages/admin/AllCourses";
import AddCourse from "./pages/admin/AddCourse";
import AllUsers from "./pages/admin/AllUsers";
import AllCoupons from "./pages/admin/AllCoupons";
import AddCoupon from "./pages/admin/AddCoupon";
import PaymentHistory from "./pages/admin/PaymentHistory";
import AllSymbols from "./pages/admin/AllSymbols";
import AddSymbol from "./pages/admin/AddSymbol";
import AllMarketHolidays from "./pages/admin/AllMarketHolidays";
import AddMarketHoliday from "./pages/admin/AddMarketHoliday";
import UpdateFyersToken from "./pages/admin/UpdateFyersToken";
import Reports from "./pages/admin/Reports";
import AdminProtectedRoute from "./AdminProtectedRoute";
import EnrolledCourses from "./pages/EnrolledCourses";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/category" element={<Category />} />
        <Route path="/category/:categoryName" element={<Category />} />
        <Route path="/course/:courseId/:courseTitle" element={<Course />} />
        <Route path="/sln-scan" element={<SLNEye />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/otp" element={<Otp />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/enrolled-courses"
          element={
            <ProtectedRoute>
              <EnrolledCourses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments"
          element={
            <ProtectedRoute>
              <Payments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/explore-course/:courseId"
          element={
            <ProtectedRoute>
              <ExploreCourse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sln-scan-live"
          element={
            <ProtectedRoute>
              <SLNScanLive />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-companies-stock"
          element={
            <ProtectedRoute>
              <AllCompaniesStock />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sector-strength"
          element={
            <ProtectedRoute>
              <SectorStrength />
            </ProtectedRoute>
          }
        />
        <Route
          path="/option-chain"
          element={
            <ProtectedRoute>
              <OptionChain />
            </ProtectedRoute>
          }
        />
        <Route
          path="/oi-liner"
          element={
            <ProtectedRoute>
              <OILiner />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/manage/all-courses"
          element={
            <AdminProtectedRoute>
              <AllCourses />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/add-course"
          element={
            <AdminProtectedRoute>
              <AddCourse />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/all-users"
          element={
            <AdminProtectedRoute>
              <AllUsers />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/all-coupons"
          element={
            <AdminProtectedRoute>
              <AllCoupons />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/add-coupon"
          element={
            <AdminProtectedRoute>
              <AddCoupon />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/payments-history"
          element={
            <AdminProtectedRoute>
              <PaymentHistory />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/all-symbols"
          element={
            <AdminProtectedRoute>
              <AllSymbols />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/add-symbol"
          element={
            <AdminProtectedRoute>
              <AddSymbol />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/market-holidays"
          element={
            <AdminProtectedRoute>
              <AllMarketHolidays />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/add-market-holiday"
          element={
            <AdminProtectedRoute>
              <AddMarketHoliday />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/manage/update-fyers-token"
          element={
            <AdminProtectedRoute>
              <UpdateFyersToken />
            </AdminProtectedRoute>
          }
        />
        
        <Route
          path="/manage/reports"
          element={
            <AdminProtectedRoute>
              <Reports />
            </AdminProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
